import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';

interface ResendInviteConfirmDialogProps {
  open: boolean;
  email: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const ResendInviteConfirmDialog: React.FC<
  ResendInviteConfirmDialogProps
> = ({ open, email, onConfirm, onCancel, isLoading }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="resend-invite-dialog-title"
      aria-describedby="resend-invite-dialog-description"
    >
      <DialogTitle id="resend-invite-dialog-title">
        Resend Invitation
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="resend-invite-dialog-description">
          Are you sure you want to resend the invitation to{' '}
          <strong>{email}</strong>? This will create a new invitation with a
          fresh expiration date.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isLoading}
          data-testid="confirm-resend-button"
        >
          {isLoading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1 }} />
              Sending...
            </>
          ) : (
            'Resend'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
